import {
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText
} from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const InputFieldValueText = () => {
  const intl = useIntl()

  const { FieldValue } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const [isDirty, setIsDirty] = useState(false)

  const handleFieldValueChange = ({ target: { value } }) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      FieldValue: value
    }))

    setIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const invalid = isDirty && !FieldValue

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.InputCustomLabel'
      })}
      required
      feedback={invalid ? requiredFeedback : undefined}
      variant={invalid ? 'danger' : undefined}
    >
      <InputText
        value={FieldValue}
        onChange={handleFieldValueChange}
        variant={invalid ? INPUT_TEXT_VARIANT_DANGER : undefined}
        maxLength={200}
      />
    </FormElement>
  )
}

export default InputFieldValueText
